import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { useTranslation } from 'react-i18next';

// import { StyledButton } from '../../../components/button/Button';

import { globalStyle } from '../../../global/style';
import './styles.scss';

// auth
import AuthService from '../../../services/auth.service';

// context
import ModeContext from '../../../context/ModeContext';

const useStyles = makeStyles(globalStyle);

export default function DataViews() {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    currentMode,
    selectList,
    currentSelectList,
    currentTextSelectList,
    handleModeClick,
    handleSelectListChange,
  } = useContext(ModeContext);

  return (
    <div className={classes.root}>
      <Grid container direction="column" spacing={5} justifyContent="center" style={{ marginTop: 10 }}>
        <Grid item>
          <FormControl component="fieldset">
            <RadioGroup row aria-label="mode" name="mode" value={currentMode}>
              <FormControlLabel
                id="select-province"
                value="province"
                control={<Radio color="primary" onClick={handleModeClick} />}
                label={<Typography variant="h6">{t('จังหวัด')}</Typography>}
              />
              {/* {AuthService.isLogin()
                ? (
                  <FormControlLabel
										id="select-basin"
                    value="basin"
                    control={<Radio color="primary" onClick={handleModeClick} />}
                    label={<Typography variant="h6">{t('ลุ่มน้ำ')}</Typography>}
                  />
                ) : null} */}
              <FormControlLabel
                id="select-basin"
                value="basin"
                control={<Radio color="primary" onClick={handleModeClick} />}
                label={<Typography variant="h6">{t('ลุ่มน้ำ')}</Typography>}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl required className={classes.formControl} style={{ width: '100%' }}>
            <Select
              labelId="demo-simple-select-required-label"
              id="demo-simple-select-required"
              value={currentSelectList}
              className={classes.selectEmpty}
              onChange={handleSelectListChange}
            >
              <MenuItem value="0">
                {t(currentTextSelectList)}
              </MenuItem>
              {selectList !== null && selectList.map((row) => (<MenuItem key={_.uniqueId()} value={row.code}>{t(row.name)}</MenuItem>))}
            </Select>
          </FormControl>

        </Grid>
        {/* <Grid item align="center">
          <FormControl required style={{ width: '70%', marginTop: 15 }}>
            <StyledButton>ตกลง</StyledButton>
          </FormControl>
        </Grid> */}
      </Grid>
    </div>
  );
}
